export const ROUTE_NAMES = {
  LIST: 'partners-list',
  CREATE: 'partners-create',
  PRICING_ETP: 'partners-pricing-etp',
  PRICING_ETR: 'partners-pricing-etr',
  DETAILS: 'partner-details'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'partners/list'
  },
  [ROUTE_NAMES.CREATE]: {
    name: ROUTE_NAMES.CREATE,
    path: 'partners/create'
  },
  [ROUTE_NAMES.PRICING_ETP]: {
    name: ROUTE_NAMES.PRICING_ETP,
    path: 'partners/:partnerId/pricing_etp'
  },
  [ROUTE_NAMES.PRICING_ETR]: {
    name: ROUTE_NAMES.PRICING_ETR,
    path: 'partners/:partnerId/pricing_etr'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: 'partners/:partnerId/details'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.CREATE].name,
    path: ROUTES[ROUTE_NAMES.CREATE].path,
    component: (resolve) => require(['./views/new-partner'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.PRICING_ETP].name,
    path: ROUTES[ROUTE_NAMES.PRICING_ETP].path,
    component: (resolve) =>
      require(['../pricing/views/pricing-etp.vue'], resolve),
    props: true
  },
  {
    name: ROUTES[ROUTE_NAMES.PRICING_ETR].name,
    path: ROUTES[ROUTE_NAMES.PRICING_ETR].path,
    component: (resolve) =>
      require(['../pricing/views/pricing-etr.vue'], resolve),
    props: true
  },
  {
    name: ROUTES[ROUTE_NAMES.DETAILS].name,
    path: ROUTES[ROUTE_NAMES.DETAILS].path,
    component: (resolve) => require(['./views/details.vue'], resolve),
    props: true
  }
]
